(function($, undefined) {
	
	'use strict';
	var session;
	var slider = $('.artist-most-played-demos-ctn');
	
	var toggleDashboardSide = function() {
		var	dashboardPage = $('.dashboard-style-page');
		var dashboardSideContent = $('.dashboard-style-page-side-content');
		var dashboardSideMinifiedContent = $('.dashboard-style-page-side-minified-content');
		dashboardPage.toggleClass('side-open');

		if (dashboardPage.hasClass('side-open')) {
			dashboardSideMinifiedContent.fadeOut(175, function() {
				dashboardSideContent.fadeIn(175);
			});
		} else {
			dashboardSideContent.fadeOut(100, function() {
				dashboardSideMinifiedContent.fadeIn(175);
			});
		}

		session.save('side-open', dashboardPage.hasClass('side-open'), function() {});
	};
	
	var initSlick = function() {
		if ($('.resp-detector-ph').css('visibility') === 'visible') {
			slider.slick({
				infinite: true,
				swipeToSlide: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				arrows: false
			});
		} else if (slider.hasClass('slick-initialized')) {
			slider.slick('unslick');
		}
	};

	var openDashboardMobileMenu = function() {
		$('.dashboard-mobile-menu-ctn').addClass('dashboard-mobile-open');
	};

	var closeDashboardMobileMenu = function() {
		$('.dashboard-mobile-menu-ctn').removeClass('dashboard-mobile-open');
	};

	var init = function () {
		session = Fw.component.models().session;

		$('.toggle-dashboard-side-btn').click(toggleDashboardSide);
		$('.dashboard-mobile-menu-toggle-btn').click(openDashboardMobileMenu);
		$('.dashboard-mobile-menu-btns-ctn').click(closeDashboardMobileMenu);

		if (slider.length) {
			initSlick();
		}

		$(window).resize(function() {
			initSlick();
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
